import {API} from "../../constAPI";

const jsonHeaders = {
  Accept: "application/json",
  "Content-type": "application/json",
};

// ─── Demos ────────────────────────────────────────────────────────

export const getAdminDemos = (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return fetch(`${API}/api/admin/demos${query ? `?${query}` : ""}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const getAdminDemo = (demoId, token) => {
  return fetch(`${API}/api/admin/demos/${demoId}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateAdminDemo = (demoId, changes, token) => {
  return fetch(`${API}/api/admin/demos/${demoId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

// ─── Assets ────────────────────────────────────────────────────────

export const getAdminDemoAssets = (token, filters = {}) => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value) params.set(key, value);
  });
  const query = params.toString();
  return fetch(`${API}/api/admin/demos/assets${query ? `?${query}` : ""}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const createAdminDemoAsset = (payload, token) => {
  return fetch(`${API}/api/admin/demos/assets`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateAdminDemoAsset = (assetId, changes, token) => {
  return fetch(`${API}/api/admin/demos/assets/${assetId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const deleteAdminDemoAsset = (assetId, token) => {
  return fetch(`${API}/api/admin/demos/assets/${assetId}`, {
    method: "DELETE",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => {
      if (response.ok) return true;
      return response.json().then((err) => Promise.reject(err));
    });
};

// ─── Policies ─────────────────────────────────────────────────────

export const getAdminDemoPolicies = (token, filters = {}) => {
  const params = new URLSearchParams();
  if (filters.vendor_id) params.set("vendor_id", filters.vendor_id);
  const query = params.toString();
  return fetch(`${API}/api/admin/demos/policies${query ? `?${query}` : ""}`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const upsertAdminDemoPolicy = (payload, token) => {
  return fetch(`${API}/api/admin/demos/policies`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateAdminDemoPolicy = (policyId, changes, token) => {
  return fetch(`${API}/api/admin/demos/policies/${policyId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

// ─── Racket Models ────────────────────────────────────────────────

export const getAdminRacketModels = (token) => {
  return fetch(`${API}/api/admin/demos/racket-models`, {
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const createAdminRacketModel = (payload, token) => {
  return fetch(`${API}/api/admin/demos/racket-models`, {
    method: "POST",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};

export const updateAdminRacketModel = (modelId, changes, token) => {
  return fetch(`${API}/api/admin/demos/racket-models/${modelId}`, {
    method: "PATCH",
    headers: {
      Authorization: `token ${token}`,
      ...jsonHeaders,
    },
    body: JSON.stringify(changes),
  })
    .then((response) => response.json())
    .catch((err) => console.log(err));
};
